/** @module SiteAdmin/User/Profile */
define([
	"dojo/_base/declare",
	"lodash",
	"csi/_base/modules",
	"csi/core/ExtendedPath",
	"csi/core/Key",
	"csi/locale",
	"csi/property/Widget",
	"csi/xml"
], function(declare, {compact}, modules, ExtendedPath, Key, locale, Widget, xml) {

	const SKIN_THEME = "SkinTheme";
	const PROOFING_EMAIL_NOTIFICATION_PREFERENCE = "ProofingEmailNotificationPreference";

	return declare(Widget, {
		propertyForceImageDimensions: true,
		propertyImageHeight: 128,
		propertyImageWidth: 128,

		/**
		 * @override
		 * Add delegation attributes to view definition so not viewed as private
		 */
		onViewInitializeAttributes() {
			const {defView} = this;

			defView.m_headings = [
				Object.assign(defView.newHeading(), {m_id: "DelegationUser"}),
				Object.assign(defView.newHeading(), {m_id: "DelegationStartTime"}),
				Object.assign(defView.newHeading(), {m_id: "DelegationEndTime"}),
			];
		},

		/**
		 * @override
		 * Override default attribute keys for view
		 */
		_resolveAttributeKeys() {
			const delegationGroupName = locale.resource("UserDelegation");
			const userSettingGroupName = locale.resource("UserSettings");
			const userPath = ExtendedPath.create("User");
			const userDetailsPath = ExtendedPath.create("User", xml.path("Details"));

			const attributeKey = (id, bDetails, omit) => {
				if (!omit) {
					return new Key({
						id,
						extendedPath: bDetails ? userDetailsPath : userPath,
					}).typedString;
				}
			};

			this.layoutByGroup = {
				[delegationGroupName]: [1, 1, 1]
			};

			this.set("attributeKeys", [
				attributeKey("UserID"),
				attributeKey("FirstName"),
				attributeKey("MiddleName"),
				attributeKey("LastName"),
				attributeKey("Node Name"),
				attributeKey("Email", true),
				attributeKey("StreetAddress", true),
				attributeKey("City", true),
				attributeKey("Province", true),
				attributeKey("PostalCode", true),
				attributeKey("Country", true),
				attributeKey("BusinessPhone", true),
				attributeKey("HomePhone", true),
				attributeKey("MobilePhone", true),
				attributeKey("Fax", true),
				{
					name: userSettingGroupName,
					keys: compact([
						attributeKey("Locale", true),
						attributeKey(SKIN_THEME, true),
						attributeKey("EnableAutoComplete"),
						attributeKey("SendNotificationEmail"),
						attributeKey(PROOFING_EMAIL_NOTIFICATION_PREFERENCE, true, !modules.hasModule("Proofing")),
						attributeKey("SendSelfBCCEmail"),
						attributeKey("EmailSignature", true),
					]),
				},
				{
					name: delegationGroupName,
					keys: [
						attributeKey("DelegationUser"),
						attributeKey("DelegationStartTime"),
						attributeKey("DelegationEndTime"),
					],
				},
			]);

			this.inherited(arguments);
		},
	});
});